<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Username:</label>
	<label class="InfoText">{{ Username }}</label>

	<label>Send Email To:</label>
	<input class="form-control" style="min-width: 300px" type="text" placeholder="abc123@email.com" [(ngModel)]="Email" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onFinish()">Send Email</button>
	<button class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
